import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FileExplorerFileTableConfig } from '../services/DoxExplorerTableConfig'
import DoxExplorerFilesTableFileCell from './doxExplorerFilesTableFileCell'
import DoxExplorerFilesTableUploaderCell from './doxExplorerFilesTableUploaderCell'
import DoxExplorerFilesTableSizeCell from './doxExplorerFilesTableSizeCell'
import DoxExplorerFilesTableModifiedCell from './doxExplorerFilesTableModifiedCell'
import DoxExplorerFilesTableManageCell from './doxExplorerFilesTableManageCell'
import DoxExplorerFilesTableCountCell from './doxExplorerFilesTableCountCell'
import Skeleton from '../../../../../../components/library/loaders/Skeleton'
import { DoxFileOperations, DoxFileOperationStatus } from '../services/doxExplorerConsts'

const DoxExplorerFilesTableRow = (props) => {
    const [errorKey, setErrorKey] = useState(null)
    const [isSelected, setIsSelected] = useState(false)

    const handleFileOperation = (operation, documentId) => {
        props.onFileOperation(operation, documentId)
    }

    const handleSelectFile = (documentId) => {
        handleFileOperation(DoxFileOperations.DOWNLOAD, documentId)
    }

    useEffect(() => {
        setIsSelected(props.fileIds?.has(props.file.documentId))
    }, [props.fileIds])

    useEffect(() => {
        let ek = null
        if (props.errorStatus === DoxFileOperationStatus.FAIL_TRANSIENT) {
            ek = 'Dox.DocumentExplorer.Errors.Transient'
        } else if (props.errorStatus === DoxFileOperationStatus.FAIL_NO_SUCH_FILE) {
            ek = 'Dox.DocumentExplorer.Errors.Removed'
        } else if (props.errorStatus === DoxFileOperationStatus.FAIL_FILE_NEEDED) {
            ek = 'Dox.DocumentExplorer.Errors.RequiredFile'
        } else if (props.errorStatus === DoxFileOperationStatus.FAIL_DELETE_CLIENT_FILE) {
            ek = 'Dox.DocumentExplorer.Errors.ClientUpload'
        } else if (props.errorStatus === DoxFileOperationStatus.FAIL_RENAME_CLIENT_FILE) {
            ek = 'Dox.DocumentExplorer.Errors.FileRename'
        } else if (props.errorStatus === DoxFileOperationStatus.FAIL_RENAME_SIGNED_FILE) {
            ek = 'Dox.DocumentExplorer.Errors.RenameSignedFiles'
        }

        if (errorKey !== ek) {
            setErrorKey(ek)
        }
    }, [props.errorStatus, setErrorKey, errorKey]);

    return (
        <div className='doxe-files-table-row hrb-columns'>
            {!props.file &&
                <Fragment>
                    <div className='trash-can placeholder' />
                    <div className='dox-skeleton hrb-column hrb-is-5'>
                        <Skeleton />
                    </div>
                    <div className='dox-skeleton hrb-column hrb-is-1'>
                        <Skeleton />
                    </div>
                    <div className='dox-skeleton hrb-column hrb-is-3'>
                        <Skeleton />
                    </div>
                    <div className='dox-skeleton hrb-column hrb-is-2'>
                        <Skeleton />
                    </div>
                    <div className='dox-skeleton hrb-column hrb-is-1'>
                        <Skeleton />
                    </div>
                </Fragment>
            }
            {props.file &&
                <Fragment>
                    <DoxExplorerFilesTableCountCell
                        errorKey={errorKey}
                        fileId={props.file.documentId}
                        fileCounter={props.fileCounter}
                        isSoftDeleted={props.file.documentStatus === 'Deleted'}
                        width={FileExplorerFileTableConfig.find(x => x.columnId === 'count').width}
                        justifyContent={FileExplorerFileTableConfig.find(x => x.columnId === 'count').justifyContent}
                        bulkDownloadEligibility={props.bulkDownloadEligibility}
                        isSelected={isSelected}
                        onFileIdSelected={props.onFileIdSelected} onFileIdRemoved={props.onFileIdRemoved} />
                    <DoxExplorerFilesTableFileCell
                        documentId={props.file.documentId}
                        fileType={props.file.fileType}
                        isSoftDeleted={props.file.documentStatus === 'Deleted'}
                        fileName={props.file.fileName}
                        onSelectItem={handleSelectFile}
                        errorKey={errorKey}
                        width={FileExplorerFileTableConfig.find(x => x.columnId === 'name').width}
                        justifyContent={FileExplorerFileTableConfig.find(x => x.columnId === 'name').justifyContent} />
                    <DoxExplorerFilesTableSizeCell fileSize={props.file.fileSize}
                        width={FileExplorerFileTableConfig.find(x => x.columnId === 'size').width}
                        justifyContent={FileExplorerFileTableConfig.find(x => x.columnId === 'size').justifyContent} />
                    <DoxExplorerFilesTableModifiedCell modifiedTs={props.file.modifiedTs}
                        width={FileExplorerFileTableConfig.find(x => x.columnId === 'modified').width}
                        justifyContent={FileExplorerFileTableConfig.find(x => x.columnId === 'modified').justifyContent} />
                    <DoxExplorerFilesTableUploaderCell uploaderIsBlock={props.file.uploaderIsBlock}
                        uploaderName={props.file.uploaderName} targetName={props.targetName}
                        width={FileExplorerFileTableConfig.find(x => x.columnId === 'uploader').width}
                        justifyContent={FileExplorerFileTableConfig.find(x => x.columnId === 'uploader').justifyContent} />
                    <DoxExplorerFilesTableManageCell documentId={props.file.documentId}
                        onFileOperation={handleFileOperation} isDownloading={props.isDownloading}
                        width={FileExplorerFileTableConfig.find(x => x.columnId === 'manage').width}
                        justifyContent={FileExplorerFileTableConfig.find(x => x.columnId === 'manage').justifyContent}
                        isSoftDeleted={props.isSoftDeleted} isRecovering={props.isRecovering} />
                </Fragment>
            }
        </div>
    )
}

DoxExplorerFilesTableRow.propTypes = {
    layoutType: PropTypes.string.isRequired,
    file: PropTypes.shape({
        documentId: PropTypes.string.isRequired,
        fileType: PropTypes.string.isRequired,
        fileName: PropTypes.string.isRequired,
        modifiedTs: PropTypes.string.isRequired
    }),
    sortColumn: PropTypes.string,
    onFileOperation: PropTypes.func.isRequired,
    isDownloading: PropTypes.bool.isRequired,
    errorStatus: PropTypes.string,
    targetName: PropTypes.string
}

export default DoxExplorerFilesTableRow